const DEBUG_MODE = false;

export const consoleLog = (msg, data) => {
  if (DEBUG_MODE) {
    console.log(msg, data);
  }
};
